let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("glcCZ")).then(() => parcelRequire('byzwL'));